module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO VERTICAL X-e28805371a9dc506640a6d9decc6c3f3.png";